import React, { ReactElement, useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import HeliosClient from 'context/Helios';
import { Context } from 'context/Context';
import { AppContext, LocationIndex } from 'context/interfaces';
import { urlIdRewrite } from 'shared/utils';
import Signature from 'components/signature/Signature';
import './Certification.scss';

interface CertificationProps {
	to: string;
}

const Certification = (props: CertificationProps): ReactElement => {
	const context = useContext(Context) as AppContext;
	const { id } = useParams<{ id: string }>();

	const handleClick = (): void => {
		if (context.certSignature) {
			new HeliosClient().saveInspection(context, id);
		}
	};

	return (
		<div>
			<div className="certification__content">
				Certifico que:
				<ol>
					<li>
						Al momento de iniciar esta reclamación, no he hecho reclamación alguna al Seguro de Responsabilidad
						Obligatorio establecido por la Ley Núm. 253 de 27 de diciembre de 1995, según enmendada (“SRO”), ni a
						cualquier otra persona, con respecto a los daños que han sido reclamados a Premier Insurance Company y/o
						podrán ser compensados por esta, y
					</li>
					<li>
						Me comprometo a no hacer reclamación alguna al SRO o cualquier otra persona, en relación con tales daños.
					</li>
				</ol>
				<p>
					Entiendo que, de cobrar alguna cantidad de dinero, ya sea del SRO, del causante del accidente o cualquier otra
					persona, por daños compensados por Premier Insurance Company, dicha actuación puede constituir fraude e
					implicar que estoy obligado a devolverle a Premier Insurance Company la suma total que me ha pagado por daños
					reclamados.
				</p>
				<p>
					Aviso - Artículo 27.320 Código de Seguros de Puerto Rico “Cualquier persona que a sabiendas y que con la
					intención de defraudar presente información falsa en una solicitud de seguro o, que presentare, ayudare o
					hiciere presentar una reclamación fraudulenta para el pago de una pérdida u otro beneficio, o presentare más
					de una reclamación por un mismo daño o pérdida, incurrirá en delito grave y convicto que fuere, será
					sancionado, por cada violación con pena de multa no menor de cinco mil dólares ($ 5,000), ni mayor de diez mil
					dólares ($ 10,000) o pena de reclusión por un término fijo de tres (3) años, o ambas penas. De mediar
					circunstancias agravantes, la pena fija establecida podrá ser aumentada hasta un máximo de cinco (5) años; de
					mediar circunstancias atenuantes, podrá ser reducida hasta un mínimo de dos (2) años.”
				</p>
				<p>Certifico, que he leído lo anterior y lo he entendido en su totalidad.</p>
				{!context.certSignature && (
					<p>
						<b>Para poder continuar complete el campo de la Firma.</b>
					</p>
				)}
			</div>

			<Signature locationIndex={LocationIndex.CERTIFICATION} />

			{context.certSignature && (
				<Link className="certification__button" to={urlIdRewrite(props.to, id)} onClick={handleClick}>
					Certifico
				</Link>
			)}
		</div>
	);
};

export default Certification;
